module.exports = __webpack_public_path__ + "img/bw.8b493920.svg";